const vueConfig = {
  productionTip: false,
  performance: process.env.NODE_ENV !== 'production',
  silent: process.env.NODE_ENV === 'production',
  ignoredElements: [ 'noindex' ]
}

export { vueConfig }
